import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import Majors from '../components/Majors'; // Komponen ini digunakan ulang untuk menampilkan kartu
import AnimatedSection from '../components/AnimatedSection';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

const RuangPublikPage = () => {
  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFacilities = async () => {
      setLoading(true);
      try {
        // Mengambil data dari koleksi 'publicFacilities'
        const facilitiesQuery = query(collection(db, 'publicFacilities'), orderBy('order', 'asc'));
        const facilitiesSnapshot = await getDocs(facilitiesQuery);
        const facilitiesData = facilitiesSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        setFacilities(facilitiesData);
      } catch (error) {
        console.error("Error fetching public facilities:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFacilities();
  }, []);

  return (
    <>
      <SEO 
        title="Ruang Publik & Fasilitas Umum - SMK Pariwisata Sumbangsih"
        description="Temukan berbagai ruang publik dan fasilitas umum yang nyaman di SMK Pariwisata Sumbangsih, termasuk kantin, lapangan olahraga, dan area komunal lainnya."
      />
      <PageHeader 
        title="Ruang Publik & Fasilitas Umum" 
        subtitle="Jelajahi berbagai ruang publik dan fasilitas umum yang kami sediakan untuk kenyamanan dan interaksi seluruh warga sekolah." 
      />
      <AnimatedSection>
        <Majors majors={facilities} loading={loading} showTitle={false} />
      </AnimatedSection>
    </>
  );
};

export default RuangPublikPage;